import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthApiFacade } from '@rx-applications/shared/auth/api';

export const AdminRoleGuard: CanMatchFn = () => {
  const authApiFacade = inject(AuthApiFacade);
  return authApiFacade.isAdmin();
};
